import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { AlertService } from '../../../providers/alert-service';
import { BensServicosService } from '../../../providers/bens-servicos-service';

/*
  Generated class for the ModalTiposIrregularidades page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-modal-tipos-bens-servicos',
    templateUrl: 'modal-bens-servicos.html',
    providers: [
        BensServicosService
    ]
})
export class ModalBensServicosPage {

    objetoCombo: any = [];
    objetoComboTipo: any;
    objeto: any;
    titulo: any;
    listaTipoBensServicos: any;

    constructor(private viewCtrl: ViewController, public navParams: NavParams, public bensServicosService: BensServicosService, private alertService: AlertService) {
        this.carregarModal();
        this.titulo = this.navParams.get('param1');
        this.objeto = this.navParams.get('param2');
    }

    carregarModal() {
        this.listarTiposBensServicos();
    }

    listarTiposBensServicos() {
        this.bensServicosService.listarTipoBensServicos().subscribe(data => this.listaTipoBensServicos = data, error => console.log("erro: " + error));
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    // addTipoBensServicos() {
    //     this.objetoComboTipo = "tipoBensServicos";
    //     this.objetoCombo = {
    //         titulo: "Adicionar Tipo",
    //         codigo: "",
    //         descricao: "",
    //         cdTipo: ""
    //     };
    // }

    onTipoBensServicosChange(novoValor) {
        this.objeto.tipoBensServicos = this.listaTipoBensServicos.filter((item) => novoValor == item.idTipoBensServicos)[0];
    }

    salvarBensServicos() {
       this.objeto.idBensServicos = this.objeto.idBensServicos ? this.objeto.idBensServicos : "0";

        this.bensServicosService.salvarNovoBemServico(this.objeto).subscribe(data => {
            this.alertService.mostraAlerta("", "Bem e Serviço Comum salvo com sucesso!");
            this.viewCtrl.dismiss();
        }, error => {
            console.log("erro: " + error);
            this.alertService.mostraAlerta("", "Houve um erro para salvar Bem e Serviço Comum.");
        });
    }

    cancelarObjetoCombo() {
        this.objetoCombo = [];
        this.objetoComboTipo = null;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-bens-servicos/modal-bens-servicos.ts